import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Link } from '@mui/material';
import { Call, Clear } from '@mui/icons-material';
import { useContext } from 'react';
import { TypographyWithCopy } from 'console/shared/components/fields';
import { Z3KSettings } from 'console/device-settings/z3k/provider/types';
export const RepaimansMaintenance = ({ specialistsList, toggleMenu, setSpecialistsList, }) => {
    const { save_device_settings } = useContext(Z3KSettings);
    const ButtonDeleteClick = (index) => {
        if (specialistsList != null) {
            const updateList = [
                ...specialistsList.slice(0, index),
                ...specialistsList.slice(index + 1),
            ];
            setSpecialistsList(updateList);
            save_device_settings({ specialists: updateList });
        }
    };
    const PrintContacts = ({ name, phone, index, }) => {
        return (_jsxs(Box, { display: "flex", gap: 2, justifyContent: "space-between", pl: 1, children: [_jsx(TypographyWithCopy, { label: name, value: phone }), toggleMenu ? (_jsx(IconButton, { size: "large", color: "error", onClick: () => ButtonDeleteClick(index), children: _jsx(Clear, {}) })) : (_jsx(IconButton, { component: Link, href: 'tel:+' + phone, disabled: phone === '', size: "large", children: _jsx(Call, {}) }))] }));
    };
    const no_info_contact = (_jsx(Box, { gap: 2, children: _jsx(TypographyWithCopy, { label: "\u041D\u0435\u0442 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043E\u0432", value: "" }) }));
    return specialistsList && specialistsList?.length !== 0 ? (_jsx(Box, { gap: 2, style: {
            width: '45%',
            minWidth: '300px',
            display: 'flex',
            flexDirection: 'column',
        }, children: specialistsList?.map((el, idx) => (_jsx(PrintContacts, { name: el.name, phone: el.phone, index: idx }, idx))) })) : (no_info_contact);
};
